<!--
  @component Navbar.MegaMenuColumn

  A column component for organizing content within a mega menu.
  It provides a way to structure content in vertical sections.

  @prop css - Custom CSS styles to apply to the column

  Example:
  <Navbar.MegaMenu>
    <Navbar.MegaMenuColumn>
      <Navbar.MegaMenuHeader title="Products" href="/products" />
      <Navbar.MegaMenuLink href="/product1" label="Product 1" />
      <Navbar.MegaMenuLink href="/product2" label="Product 2" />
    </Navbar.MegaMenuColumn>
  </Navbar.MegaMenu>
-->

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { megaMenuStyles } from '../navbar.styles';
  import type { NavbarMegaMenuColumnProps } from '../navbar.types';

  /** Props for the Navbar.MegaMenuColumn component */
  const { children, css: cssProp }: NavbarMegaMenuColumnProps = $props();

  /** Styles for the mega menu column */
  const styles = megaMenuStyles.raw();
</script>

<div class={css(styles.column, cssProp)}>
  {@render children?.()}
</div>
